<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import UpdateCardForm from '../public/checkout/update-card-form.svelte'
    import Fa from 'svelte-fa'
    import { faCopy } from '@fortawesome/free-solid-svg-icons'
    // ##############################################################################################################
    const dispatch = createEventDispatcher()

    export let purchaseId: string

    onMount(async () => {
        await updateLink()
    })

    let linkUrl: string = ''

    function updateLink() {
        let r = ''
        linkUrl = window.api.utils.utils.domain() + '/public/checkout-card?id=' + purchaseId
    }

    let linkField
    function copyLink() {
        linkField.select()
        linkField.setSelectionRange(0, 99999) /* For mobile devices */
        window.api.utils.utils.copyToClipboard(linkField.value)
        window.alert('Link copiado')
    }
</script>

<div class="root">
    <div class="grid-form">
        <div class="row">
            <div class="col">
                <div class="input-group">
                    <label for="" class="input-group-text">Link do cliente</label>
                    <input type="text" bind:this={linkField} id="divLink" class="form-control token-link" value={linkUrl} />
                    <button class="btn btn-primary" on:click={copyLink}><Fa icon={faCopy} /> Copiar link</button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col mb-3">
                <UpdateCardForm {purchaseId} />
            </div>
        </div>
    </div>
</div>

<style>
    .row {
        padding: 0px 16px;
    }
</style>
